/*
 * Global registration.
 */

type NavigateToLink = (link: string) => Promise<boolean>;
let navigateToLinkAsync: NavigateToLink | undefined;

// TODO: Find other way to connect these than to register on a global level.
export function registerNavigateToLinkFunction(value: NavigateToLink) {
  navigateToLinkAsync = value;
}

export async function tryNavigateToLinkAsync(link: string) {
  if (!navigateToLinkAsync) {
    return;
  }

  await navigateToLinkAsync(link);
}
